import { supabase } from './supabaseClient';

class EmbedStorage {
  _toApp(row) {
    return {
      id: row.id,
      title: row.title,
      slug: row.slug,
      toolUrl: row.tool_url,
      brand: row.brand,
      layout: row.layout,
      iframe: row.iframe,
      sectionId: row.section_id,
      order: row.order,
      views: row.views,
      createdAt: row.created_at,
      updatedAt: row.updated_at
    };
  }

  _toDb(data) {
    const row = {};
    if (data.title !== undefined) row.title = data.title;
    if (data.slug !== undefined) row.slug = data.slug;
    if (data.toolUrl !== undefined) row.tool_url = data.toolUrl;
    if (data.brand !== undefined) row.brand = data.brand;
    if (data.layout !== undefined) row.layout = data.layout;
    if (data.iframe !== undefined) row.iframe = data.iframe;
    if (data.sectionId !== undefined) row.section_id = data.sectionId;
    if (data.order !== undefined) row.order = data.order;
    if (data.views !== undefined) row.views = data.views;
    return row;
  }

  async getAllEmbeds() {
    const { data, error } = await supabase
      .from('embeds')
      .select('*')
      .order('order', { ascending: true });

    if (error) throw error;
    return (data || []).map(row => this._toApp(row));
  }

  async getEmbedBySlug(slug) {
    const { data, error } = await supabase
      .from('embeds')
      .select('*')
      .eq('slug', slug)
      .single();

    if (error && error.code !== 'PGRST116') throw error;
    return data ? this._toApp(data) : null;
  }

  async createEmbed(embedData) {
    const row = {
      ...this._toDb(embedData),
      section_id: embedData.sectionId || 'default',
      views: 0
    };

    const { data, error } = await supabase
      .from('embeds')
      .insert(row)
      .select()
      .single();

    if (error) throw error;
    return this._toApp(data);
  }

  async updateEmbed(id, embedData) {
    const row = {
      ...this._toDb(embedData),
      updated_at: new Date().toISOString()
    };

    const { data, error } = await supabase
      .from('embeds')
      .update(row)
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return this._toApp(data);
  }

  async deleteEmbed(id) {
    const { error } = await supabase
      .from('embeds')
      .delete()
      .eq('id', id);

    if (error) throw error;
  }

  async trackView(embedId) {
    const { error } = await supabase.rpc('track_embed_view', { p_embed_id: embedId });
    if (error) console.error('Failed to track view:', error);
  }

  async getAnalytics(embedId, days = 30) {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - (days - 1));
    const startStr = startDate.toISOString().split('T')[0];

    const { data, error } = await supabase
      .from('embed_analytics')
      .select('view_date, view_count')
      .eq('embed_id', embedId)
      .gte('view_date', startStr)
      .order('view_date', { ascending: true });

    if (error) throw error;

    const viewMap = {};
    (data || []).forEach(row => {
      viewMap[row.view_date] = row.view_count;
    });

    const result = [];
    const today = new Date();
    for (let i = days - 1; i >= 0; i--) {
      const date = new Date(today);
      date.setDate(date.getDate() - i);
      const dateStr = date.toISOString().split('T')[0];
      result.push({ date: dateStr, views: viewMap[dateStr] || 0 });
    }

    return result;
  }
}

export const embedStorage = new EmbedStorage();
